<script setup lang="ts">
import { NCollapse } from 'naive-ui'
import { useAttrs } from 'vue'

interface CollapseItem {
  title: string
  name: string | number
  disabled?: boolean
  [key: string]: any
}

const props = withDefaults(defineProps<{
  accordion?: boolean
  defaultExpandedNames?: Array<string | number>
  expandedNames?: Array<string | number>
  displayDirective?: 'if' | 'show'
  arrowPlacement?: 'left' | 'right'
  onUpdateExpandedNames?: (expandedNames: Array<string | number>) => void
  onItemHeaderClick?: (data: { name: string | number; expanded: boolean; event: MouseEvent }) => void
}>(), {
  accordion: false,
  defaultExpandedNames: () => [],
  expandedNames: () => [],
  displayDirective: 'if',
  arrowPlacement: 'left',
})

const emit = defineEmits<{
  'update:expandedNames': [expandedNames: Array<string | number>]
  'item-header-click': [data: { name: string | number; expanded: boolean; event: MouseEvent }]
}>()

const attrs = useAttrs()

const onUpdateExpandedNames = (expandedNames: Array<string | number>) => {
  emit('update:expandedNames', expandedNames)
}

const onItemHeaderClick = (data: { name: string | number; expanded: boolean; event: MouseEvent }) => {
  emit('item-header-click', data)
}
</script>

<template>
  <NCollapse
    :accordion="accordion"
    :default-expanded-names="defaultExpandedNames"
    :expanded-names="expandedNames"
    :display-directive="displayDirective"
    :arrow-placement="arrowPlacement"
    v-bind="attrs"
    @update:expanded-names="onUpdateExpandedNames"
    @item-header-click="onItemHeaderClick"
  >
    <template #default>
      <slot />
    </template>
    <template #arrow>
      <slot name="arrow" />
    </template>
  </NCollapse>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
